import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { name: 'About', path: '/about' },
    { name: 'Programs', path: '/programs' },
    { name: 'Donate', path: '/donate' },
    { name: 'CSR', path: '/csr' },
    { name: 'Policies', path: '/policies' },
  ];

  return (
    <footer className="bg-[#FAFAFA] border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/9842b5143901a0019f067b22648287f2/e02ccdad9401b4ae7d91a47c24564639.png" 
                alt="Diatomic Life Foundation" 
                className="w-8 h-8 object-contain"
              />
              <span className="text-xl font-bold text-[#111111] font-display">
                Diatomic Life Foundation
              </span>
            </div>
            <div className="text-sm text-gray-600 space-y-2">
              <p>CIN: U86900DL2025NPL447067</p>
              <p>Section-8 Non-Profit Organization</p>
              <p>80G Tax Exemption Available</p>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-[#111111]">Contact</h3>
            <div className="text-sm text-gray-600 space-y-2">
              <div className="flex items-start space-x-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center text-[#12B6B6] mt-0.5"></i>
                <span>A-88/7, Second Floor, Road No.2, Mahipalpur Extension, New Delhi - 110037, India</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center text-[#12B6B6]"></i>
                <span>Oxygen@diatomic.life</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center text-[#12B6B6]"></i>
                <span>+91 8010700200</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-[#111111]">Quick Links</h3>
            <div className="flex flex-col space-y-2">
              {quickLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-sm text-gray-600 hover:text-[#12B6B6] transition-colors duration-200"
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-600 hover:text-[#12B6B6] transition-colors duration-200"
              >
                Made with Readdy
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-600">
            © 2024 Diatomic Life Foundation. All rights reserved. | 
            <Link to="/privacy" className="hover:text-[#12B6B6] ml-1">Privacy Policy</Link> | 
            <Link to="/terms" className="hover:text-[#12B6B6] ml-1">Terms of Service</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
